import SearchIcon from 'common/components/svg-icon/search';
import styles from './styles.less';
import { observer } from 'mobx-react';


const ShowSearch = (props) => {
    function handleChange(e) {
        e.preventDefault();
        props.onChange(e.target.value);
    }
    return (
        <div className={ cx(styles.root, props.className, { [styles.inputEmpty]: !props.value }) }>
            <div className={ styles.inputContainer }>
                <input
                    className={ styles.input }
                    onChange={ handleChange }
                    type='text'
                    value={ props.value }
                />
                <SearchIcon className={ styles.searchIcon } />
            </div>
        </div>
    );
};

ShowSearch.propTypes = {
    onChange: React.PropTypes.func.isRequired,
    value: React.PropTypes.string.isRequired
};

ShowSearch.defaultProps = {
    value: ''
};


export default observer(ShowSearch);



// WEBPACK FOOTER //
// ./src/show-index/components/show-search/index.js